/* Jerzify layer: hero slideshow, product tabs, rail arrows, review photo zoom, logo menu
   aria state and scroll reveal. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ---------- */
  function reveal(root) {
    var els = (root || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- hero ---------- */
  function hero(root) {
    if (root.__jz) return; root.__jz = true;
    var slides = root.querySelectorAll('[data-slide]');
    var bars = root.querySelectorAll('[data-go]');
    if (slides.length < 2) return;
    var secs = parseInt(root.getAttribute('data-speed'), 10) || 6;
    root.style.setProperty('--dur', secs + 's');
    var i = 0, timer = null, paused = reduce, hover = false;

    function show(n) {
      n = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === n;
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a').forEach(function (a) { a.tabIndex = on ? 0 : -1; });
        if (on) s.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
      });
      bars.forEach(function (b, k) {
        b.classList.remove('is-on');
        b.classList.toggle('is-done', k < n);
        b.setAttribute('aria-selected', k === n ? 'true' : 'false');
      });
      var bar = bars[n];
      if (bar) { void bar.offsetWidth; bar.classList.add('is-on'); }
      i = n;
      // warm the next slide's photos
      var next = slides[(n + 1) % slides.length];
      next.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
      schedule();
    }
    function schedule() {
      clearTimeout(timer);
      if (paused || hover) return;
      timer = setTimeout(function () { show(i + 1); }, secs * 1000);
    }
    function setPaused(p) {
      paused = p; root.classList.toggle('is-paused', p || hover);
      var btn = root.querySelector('[data-pause]');
      if (btn) btn.setAttribute('aria-pressed', p ? 'true' : 'false');
      if (!p && !hover) { var b = bars[i]; if (b) { b.classList.remove('is-on'); void b.offsetWidth; b.classList.add('is-on'); } }
      schedule();
    }
    bars.forEach(function (b) {
      b.addEventListener('click', function () { show(parseInt(b.getAttribute('data-go'), 10)); });
    });
    var pb = root.querySelector('[data-pause]');
    if (pb) pb.addEventListener('click', function () { setPaused(!paused); });
    root.addEventListener('mouseenter', function () { hover = true; root.classList.add('is-paused'); clearTimeout(timer); });
    root.addEventListener('mouseleave', function () {
      hover = false; root.classList.toggle('is-paused', paused);
      if (!paused) { var b = bars[i]; if (b) { b.classList.remove('is-on'); void b.offsetWidth; b.classList.add('is-on'); } schedule(); }
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else schedule(); });

    // swipe
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(i + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    if (reduce) root.classList.add('is-paused');
    show(0);
  }

  /* ---------- tabs ---------- */
  function tabs(root) {
    if (root.__jzt) return; root.__jzt = true;
    var btns = root.querySelectorAll('[data-tab]');
    if (!btns.length) return;
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.getAttribute('data-tab');
        btns.forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        root.querySelectorAll('[data-pane]').forEach(function (p) {
          var on = p.getAttribute('data-pane') === n;
          p.hidden = !on; p.classList.toggle('is-on', on);
          if (on) { reveal(p); var r = p.querySelector('[data-rail]'); if (r) { r.scrollLeft = 0; arrows(root); } }
        });
        root.querySelectorAll('[data-tab-link]').forEach(function (a) { a.classList.toggle('is-hidden', a.getAttribute('data-tab-link') !== n); });
      });
    });
  }

  /* ---------- rail arrows ---------- */
  function activeRail(sec) {
    var rails = sec.querySelectorAll('[data-rail]');
    for (var k = 0; k < rails.length; k++) { if (rails[k].offsetParent !== null) return rails[k]; }
    return rails[0];
  }
  function arrows(sec) {
    var rail = activeRail(sec); if (!rail) return;
    var prev = sec.querySelector('[data-rail-prev]'), next = sec.querySelector('[data-rail-next]');
    if (!prev || !next) return;
    var max = rail.scrollWidth - rail.clientWidth - 2;
    prev.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft >= max;
    var hide = rail.scrollWidth <= rail.clientWidth + 4;
    prev.style.display = next.style.display = hide ? 'none' : '';
  }
  function rails(sec) {
    if (sec.__jzr) return; sec.__jzr = true;
    var prev = sec.querySelector('[data-rail-prev]'), next = sec.querySelector('[data-rail-next]');
    function go(dir) {
      var rail = activeRail(sec); if (!rail) return;
      var cell = rail.firstElementChild;
      var step = cell ? cell.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
      var per = Math.max(1, Math.floor(rail.clientWidth / step));
      rail.scrollBy({ left: dir * step * per, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    sec.querySelectorAll('[data-rail]').forEach(function (r) {
      r.addEventListener('scroll', function () { arrows(sec); }, { passive: true });
    });
    window.addEventListener('resize', function () { arrows(sec); });
    arrows(sec);
  }

  /* ---------- review photo zoom ---------- */
  function zoom(sec) {
    if (sec.__jzz) return; sec.__jzz = true;
    var box = sec.querySelector('[data-zoom-box]'); if (!box || !box.showModal) return;
    var img = box.querySelector('img');
    sec.querySelectorAll('[data-zoom]').forEach(function (b) {
      b.addEventListener('click', function () { img.src = b.getAttribute('data-zoom'); box.showModal(); });
    });
    box.addEventListener('click', function (e) { if (e.target === box || e.target.hasAttribute('data-zoom-close')) box.close(); });
  }

  /* ---------- logo menu: hover intent, instant switching, page dim ---------- */
  function nav(root) {
    if (root.__jzn) return; root.__jzn = true;
    var open = null, tIn = null, tOut = null;
    var html = document.documentElement;
    function close(li, now) {
      if (!li) return;
      if (now) root.classList.add('is-swap');
      li.classList.remove('is-open');
      var a = li.querySelector('.jzn__top'); if (a) a.setAttribute('aria-expanded', 'false');
      if (open === li) { open = null; html.classList.remove('jzn-dim'); }
    }
    function show(li) {
      var swap = open && open !== li;
      if (swap) close(open, true);
      li.classList.add('is-open');
      var a = li.querySelector('.jzn__top'); if (a) a.setAttribute('aria-expanded', 'true');
      open = li; html.classList.add('jzn-dim');
      if (swap) requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.remove('is-swap'); }); });
    }
    root.querySelectorAll('.jzn__item').forEach(function (li) {
      var hasPanel = li.classList.contains('has-panel');
      li.addEventListener('mouseenter', function () {
        clearTimeout(tOut); clearTimeout(tIn);
        if (!hasPanel) { tOut = setTimeout(function () { close(open); }, 120); return; }
        if (open) show(li); else tIn = setTimeout(function () { show(li); }, 90);
      });
      li.addEventListener('mouseleave', function () {
        clearTimeout(tIn);
        tOut = setTimeout(function () { close(open); }, 160);
      });
      if (!hasPanel) return;
      var hush = false;
      li.addEventListener('focusin', function () { clearTimeout(tOut); if (!hush) show(li); hush = false; });
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) close(li); });
      li.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var a = li.querySelector('.jzn__top'); close(li);
        if (a && document.activeElement !== a) { hush = true; a.focus(); }
      });
    });
    window.addEventListener('scroll', function () { if (open) close(open); }, { passive: true });

    // grouped panels: hovering a group on the left shows its logos on the right
    root.querySelectorAll('[data-jzn-tabs]').forEach(function (box) {
      var tabs = box.querySelectorAll('[data-jzn-tab]');
      function pick(t) {
        var n = t.getAttribute('data-jzn-tab');
        tabs.forEach(function (x) { x.classList.toggle('is-on', x === t); });
        box.querySelectorAll('[data-jzn-pane]').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-jzn-pane') === n); });
      }
      tabs.forEach(function (t) {
        var timer = null;
        t.addEventListener('mouseenter', function () { timer = setTimeout(function () { pick(t); }, 60); });
        t.addEventListener('mouseleave', function () { clearTimeout(timer); });
        t.addEventListener('focus', function () { pick(t); });
      });
    });
  }

  /* ---------- product page: Fan vs Player picks the version ---------- */
  function versions(box) {
    if (box.__jzv) return; box.__jzv = true;
    var name = box.getAttribute('data-option');
    var root = box.closest('section, .shopify-section') || document;
    function radios() {
      return Array.prototype.filter.call(root.querySelectorAll('input[type="radio"]'), function (r) { return r.name === name; });
    }
    function sync() {
      var cur = radios().filter(function (r) { return r.checked; })[0];
      var sel = root.querySelector('select[name="options[' + name + ']"]');
      var val = cur ? cur.value : (sel ? sel.value : null);
      box.querySelectorAll('[data-pick]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-pick') === val); });
    }
    box.querySelectorAll('[data-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-pick');
        var r = radios().filter(function (x) { return x.value === v; })[0];
        if (r) { r.click(); }
        else {
          var sel = root.querySelector('select[name="options[' + name + ']"]');
          if (sel) { sel.value = v; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        }
        setTimeout(sync, 30);
      });
    });
    root.addEventListener('change', function () { setTimeout(sync, 30); });
    sync();
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-jz-versions]').forEach(versions);
    scope.querySelectorAll('[data-jz-hero]').forEach(hero);
    scope.querySelectorAll('[data-jz-tabs]').forEach(tabs);
    scope.querySelectorAll('.jzp, .jzr, .jzk').forEach(rails);
    scope.querySelectorAll('.jzr').forEach(zoom);
    scope.querySelectorAll('.jzn').forEach(nav);
    reveal(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // theme editor: re-run on section reloads
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target.closest('[data-jz-hero]');
    if (s) { var k = Array.prototype.indexOf.call(s.querySelectorAll('[data-slide]'), e.target); var b = s.querySelectorAll('[data-go]')[k]; if (b) b.click(); }
  });
})();
